import React from "react";

const Tour = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
              d="M3.563 2h28.875c.827.214 1.344.738 1.562 1.562v1c-.023.057-.047.113-.067.171-.24.752-.74 1.213-1.522 1.353a2.42 2.42 0 0 1-.403.03c-.49.003-.98-.001-1.469.001-1.286.008-2.109.828-2.109 2.112-.002 5.802 0 11.603 0 17.405v.41H24.95c-.747-1.618-1.92-2.845-3.504-3.688 3.18-2.307 3.378-6.573.953-9.14-2.366-2.505-6.35-2.528-8.741-.062a6.071 6.071 0 0 0 .881 9.193c-.02.022-.037.053-.063.067-1.5.8-2.616 1.967-3.362 3.495-.039.08-.193.143-.294.144-1 .01-2 .006-3 .005-.078 0-.156-.017-.25-.028V8.23C7.57 6.943 6.75 6.125 5.462 6.117c-.52-.003-1.041.004-1.562-.001-.57-.006-1.076-.2-1.427-.654-.204-.264-.318-.597-.473-.9v-1c.217-.825.737-1.347 1.563-1.562Z"
              fill={fill}
        />
        <path className="u_fill"
              d="M13 34c-.555-.21-.752-.62-.74-1.197.03-1.415-.03-2.834.06-4.244.158-2.495 2.261-4.696 4.735-5.06 3.213-.474 6.011 1.524 6.592 4.72.065.355.081.723.084 1.087.01 1.166-.01 2.331.01 3.497.01.576-.187.989-.742 1.197H13ZM2 7.5c.702.393 1.466.507 2.257.498.405-.005.811.002 1.217-.005.16-.002.235.053.223.217-.005.062 0 .125 0 .187v22.386c0 .073.001.146-.003.219-.02.38-.25.615-.637.623-.437.01-.876.027-1.311-.008-.788-.061-1.331-.48-1.628-1.214-.037-.094-.079-.186-.118-.279V7.5ZM34 30.062c-.041.116-.08.234-.123.35a1.846 1.846 0 0 1-1.665 1.21c-.416.014-.834.012-1.25.004-.419-.009-.645-.246-.658-.67-.002-.072 0-.145 0-.218V8.431c0-.436 0-.436.438-.436.354 0 .708 0 1.062.002.77.007 1.512-.115 2.195-.498v22.563ZM13.817 17.342c.007-2.288 1.9-4.161 4.198-4.153 2.294.009 4.162 1.89 4.162 4.19 0 2.286-1.892 4.17-4.183 4.17-2.305 0-4.183-1.892-4.177-4.207Z"
              fill={fill}
        />
    </svg>
);

export default Tour;
